export default __webpack_public_path__ + "static/media/house.e459bd09.png";